import * as t from 'io-ts';

const PhraseApp = t.exact(t.interface({
  accessToken: t.union([t.string, t.null]),
  projectId: t.union([t.string, t.null]),
}), 'PhraseApp');

export type IPhraseApp = t.TypeOf<typeof PhraseApp>;

export default PhraseApp;
